import { render, staticRenderFns } from "./profile-associate-edit.vue?vue&type=template&id=10c18e0d&scoped=true"
import script from "./profile-associate-edit.vue?vue&type=script&lang=js"
export * from "./profile-associate-edit.vue?vue&type=script&lang=js"
import style0 from "./profile-associate-edit.vue?vue&type=style&index=0&id=10c18e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c18e0d",
  null
  
)

export default component.exports